import { Space } from "antd";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import IconButton from "../../../components/common/IconButton";
import UserTable from "../../../components/NP/User/UserTable";
import Subheader from "../../../components/ui/Subheader";
import { pathLink } from "../../../helpers/siteConfig";
import useDebounce from "../../../hooks/useDebounce";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import { getCountUsersAsync } from "../../../store/features/NP/resource/resourceAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";

export default function User() {
  const location = useLocation();
  const path = pathLink(location.pathname, 1);
  const { keyword, handleInputChange, handleEnterValue } = useDebounce();
  const dispatch = useAppDispatch();
  const { handleSetFirstPage, ...rest } = useTable();
  const { login } = useAppSelector((state) => state.login);
  const { loading, usersCount } = useAppSelector((state) => state.resource);

  useEffect(() => {
    const params: any = {
      isPG: false,
      suppler: "",
      lastName: keyword,
    };

    dispatch(
      getCountUsersAsync({
        params,
      })
    );
  }, [dispatch, keyword, login?.suppler]);

  return (
    <>
      <AdminLayout title="User List" headerTitle="User">
        <section className="mt-7">
          <Subheader
            title="User List"
            subTitle={`Total User: ${usersCount?.totalUsers}`}
          >
            <Space size="middle">
              {/* <Search
                placeholder="Search by name"
                onSearch={(val) => {
                  handleEnterValue(val);
                  handleSetFirstPage(true);
                }}
                onChange={(val) => {
                  handleInputChange(val);
                  handleSetFirstPage(true);
                }}
                className="custom-search-input"
              /> */}
              <Link to={`/${path}/user/create`}>
                <IconButton type="primary" nextIcon={<AddIcon />}>
                  Add New
                </IconButton>
              </Link>

              {/* <IconButton
                type="primary"
                nextIcon={<AddIcon />}
                onClick={() =>
                  handleAddPoOpen({
                    type: "ADD_NEW_PO",
                  })
                }
              >
                Add New PO
              </IconButton> */}
            </Space>
          </Subheader>

          <UserTable
            keyword={keyword}
            handleSetFirstPage={handleSetFirstPage}
            {...rest}
          />
        </section>
      </AdminLayout>
    </>
  );
}
